// extracted by mini-css-extract-plugin
module.exports = {"textPrompt":"ModalUpdateListingDetailsConfirmation_textPrompt__iIX0u"};